export class UpdateCloudEnvironmentRequest {
    environmentId?: string;
    description?: string;
    isAvailable?: boolean;
    isEnabled?: boolean;
    inMaintenanceMode?: boolean;
    statusMessage?: string;
}